// extracted by mini-css-extract-plugin
export var bubble = "_28-0";
export var container = "_28-f";
export var contrastBorder = "_28-g";
export var greyOut = "_28-2";
export var initialsColor0 = "_28-3";
export var initialsColor1 = "_28-4";
export var initialsColor10 = "_28-d";
export var initialsColor11 = "_28-e";
export var initialsColor2 = "_28-5";
export var initialsColor3 = "_28-6";
export var initialsColor4 = "_28-7";
export var initialsColor5 = "_28-8";
export var initialsColor6 = "_28-9";
export var initialsColor7 = "_28-a";
export var initialsColor8 = "_28-b";
export var initialsColor9 = "_28-c";
export var initialsWrapper = "_28-1";
export var large = "_28-l";
export var medium = "_28-k";
export var mediumSmall = "_28-j";
export var mediumSmallMedium = "_28-o";
export var micro = "_28-h";
export var small = "_28-i";
export var tiny = "_28-n";
export var xTiny = "_28-m";